module.exports = __webpack_public_path__ + "static/img/video_poster.cc99181.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appDownload/video_poster.jpg
// module id = N2XE
// module chunks = 0